import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import InfiniteScroll from "react-infinite-scroll-component";
import { getMoreReviews } from "../../Redux/Specialist/actions";
import InfiniteScrollView from "../../Components/InfiniteScrollView";


export const ReviewItem = ({ review, lastClass, index }) => {
    return (
        <div className={"column is-6 "+lastClass}>
        <div className="comment">
          <div className="comment-head">
            <a>
              <img  
                    src={review?.reviewer?.image || require("../../assets/images/placeholder.png").default} 
                    alt="" />
            </a>
            <div className="meta">
              <h4 className="title is-6 is-narrow">{review?.reviewer?.name} <span> <i className="la la-star" style={{ color: "#ffb536" }} /> {review?.rating}</span></h4>
              <span>{review?.date}</span>
            </div>
          </div>
          <p>
            {review?.comment}
          </p>
        </div>
      </div>
    )
}


const ReviewModals = (props) => {
    const { reviews } = props;
    const [loadMoreParams, setLoadMoreParams] = React.useState()

    const fetchMoreData = (params) => {
        if(!params?.reviews?.results) return;
        props.getMoreReviews(params);
    }

    React.useEffect(() => {
        if(props?.reviews?.results?.length > 0) setLoadMoreParams({ profile: props?.profile, reviews: props?.reviews, username: props.username })
    }, [reviews])

	return (
						<div className="comments-modal-content">
                        {/* <div id="load-more-comment-seeee" style={{ width: "max-content", margin: "auto" }}><button className="button "  onClick={() => fetchMoreData()}>Loading...</button></div> */}
                            <div 
                                id="review-list-items-id" 
                                className="comments is-bigger has-slimscroll">
                                <InfiniteScrollView 
                                    lastItemClass="review-last-class-item" 
                                    viewId="review-list-items-id"
                                    isLoading={props?.reviews?.isLoading}
                                    loadMoreParams={loadMoreParams}
                                    loadMore={(params) => {
                                        fetchMoreData(params);
                                    }}
                                    renderIsLoading={() => {
                                        return <div style={{ width: "max-content", margin: "auto" }}><button className="button is-loading border-none">Loading...</button></div>
                                    }}
                                    >
                                    <div className="columns is-multiline b-columns-half-tablet-p">
                                        {(props?.reviews?.results||[]).map((review, i) => {
                                            return <><ReviewItem key={v4()} index={i} review={review} lastClass={ i === props?.reviews?.results?.length - 1 ? "review-last-class-item" :"" } /></>
                                        })}
                                    </div>
                                </InfiniteScrollView>
							</div>
						</div>

	);
};

export default ReviewModals;

// const mapStateToProps = ({ specialist }) => {
// 	return { specialist };
// };

// const mapDispatchToProps = (dispatch) => {
// 	return { 
//         getMoreReviews: e => dispatch(getMoreReviews(e))
//      }
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ReviewModals);
